import React, { Component } from "react";
import posed from "react-pose";
import onClickOutside from "react-onclickoutside";
import classes from "./Card.module.css";

class ProjectCard extends Component {

  handleClickOutside = evt => {
    this.props.goBack();
  };

  render() {
    const Box = posed.div({
      hoverable: true,
      pressable: true,
      init: {
        scale: 1,
        boxShadow: "0px 5px 10px rgba(0,0,0,0.2)"
      },
      // hover: {
      //   scale: 1.2,
      //   boxShadow: "0px 5px 10px rgba(0,0,0,0.2)"
      // },
      press: {
        scale: 0.95,
        boxShadow: "0px 2px 5px rgba(0,0,0,0.1)"
      }
    });

    return (
      <Box className="box">
        <div className={classes.ProjectCard}>
          <div>
            <img
              onClick={this.props.goBack}
              src="https://img.icons8.com/material/48/000000/delete-sign.png"
              alt="close"
              height="24"
              width="24"
            />
          </div>
          {this.props.children}
        </div>
      </Box>
    );
  }
}

export default onClickOutside(ProjectCard);
